function open_close_drawer(){  
   $('body').addClass('open_cart');
   if( $(".overlay_widget").length < 1){
     $('body').append('<div class="overlay_widget">&nbsp;</div>');
   }
   $(document).on('click', '.overlay_widget, .close_drawer', function(){
     $('body').removeClass('open_cart');
     $('.overlay_widget').remove();
   });
};

function create_cart(){
   jQuery.getJSON('/cart.js', function(cart) {
    $('.cart_icon .cart_itm_count').text($('.cart_basket_dv .cart_itm_count').text());      
     $('.cart_drawer').load('/ .inner_cart_drawer',  function(){
        $('.free_pro_slider').slick({
          slidesToShow: 3,
          infinite: false,
         prevArrow:"<button type='button' class='slick-prev slick-arrow'><svg data-v-1c696121='' width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g data-v-1c696121='' stroke-width='1' fill='none' fill-rule='evenodd'><polyline data-v-1c696121='' transform='translate(11.000000, 12.000000) scale(-1) translate(-11.000000, -12.000000)' points='9 6 15 12 9 18'></polyline></g></svg></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><svg data-v-1c696121='' width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g data-v-1c696121='' stroke-width='1' fill='none' fill-rule='evenodd'><polyline data-v-1c696121='' points='9 6 15 12 9 18' class='caret_lines'></polyline></g></svg></button>"
    });
       checkbox_length();

       search_autocomplete();
     });
   });
}

$(document).on('click','.btn_class',function(){
  var temp_form_id = $(this).attr('data-id'),
      temp_form_val = $(this).parents('.btn_qty').find('.quantity__input').val() || 1;
  addtocart_product(temp_form_id, temp_form_val);
  setTimeout(function() {
    open_close_drawer();
  }, 1000);
  return false;
});

$(document).on('click','.cart_icon', function(){
  open_close_drawer();
  return false;
});

$(document).on('click','.remove_item', function(){
  var data_id = $(this).attr('data-id');
  $(this).parents('.cart_item').fadeOut(500);
  remove_product(data_id);
  return false;
});

function remove_product(variantId, quantity){
  var quantity = 0;
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + variantId,
    dataType: 'json',
    success: function(line_item) { 
      create_cart();
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('error');
      }
    };
  jQuery.ajax(params);
};

function addtocart_product(variantId, quantity){
  var quantity = quantity;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variantId,
    dataType: 'json',
    success: function(line_item) { 
      create_cart();
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('error');
      }
    };
  jQuery.ajax(params);
};

function update_qty(line, qty){
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: "quantity="+qty+"&line=" + line,
    dataType: 'json',
    success: function(cart) {
      create_cart();
      if(qty > 0 ){
        if((cart.items[line-1].quantity) != qty){
          alert ("You have only " + cart.items[line-1].quantity + " quantity available in stock. ");
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.api.onError(XMLHttpRequest, textStatus);
    }
  }; 
  $.ajax(params);
}

$(document).on('click', '.QuantityBox .plus', function() {            
  var $qty = $(this).parents('.QuantityBox').find(".cart_qty_input"),
    currentVal = parseInt($qty.val(), 10),
    line = $(this).parents('.QuantityBox').attr('data-line');
  if (1 <= currentVal) {
    $(this).parents('.QuantityBox').find('.minus_box').removeClass('disabled');
  }
  if (!isNaN(currentVal)) { 
    $qty.val(currentVal + 1);
    var qty = $qty.val();
    update_qty(line, qty)
  } 
});

$(document).on('click', '.QuantityBox .minus', function() { 
  var $qty = $(this).parents('.QuantityBox').find(".cart_qty_input"),
   currentVal = parseInt($qty.val(), 10),
    line = $(this).parents('.QuantityBox').attr('data-line');
  if (currentVal <= 1) {
    $(this).parents('.QuantityBox').find('.minus_box').addClass('disabled');
  }
  if (!isNaN(currentVal) && currentVal > 0) {
    $qty.val(currentVal - 1);
    var qty = $qty.val();
    update_qty(line, qty)
  }
});

create_cart();

function checkbox_length(){
  var check_length = $('.pro_dec_dv input:checked').length;
  $('.pro_dec_dv input:checked').parents('.pro_dec_dv').find('.free_cart').text('added')
  if(check_length >= 2){
    $('.pro_dec_dv input').each(function(){
      if(!$(this).is(':checked')){
        $(this).parents('.pro_dec_dv').find('.free_cart').attr('disabled', true);
      }
    })
  }
  else{
    $('.free_cart').attr('disabled', false)
  }
}
$(document).change('.free_cart', function(event){
  var target = $(event.target ),
    data_id = target.attr('data-id');
    checkbox_length();
    if(!target.is(':checked')){
      target.next().text('add')
      var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + 0 + '&id=' + data_id,
      dataType: 'json',
      success: function(line_item) { 
        
      },
      error: function(XMLHttpRequest, textStatus) {
          console.log('error');
        }
      };
      jQuery.ajax(params);
    }
  else{
    target.next().text('added')
    var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + 1 + '&id=' + data_id,
    dataType: 'json',
    success: function(line_item) {
      
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('error');
      }
    };
  jQuery.ajax(params);
  }
});

/*---search_auto_complete---*/
function search_autocomplete(){
var lis = document.getElementById("CountryList").getElementsByTagName("li");
var suggestions = [];
for(var i=0; i<lis.length; i++){
   suggestions.push(lis[i].innerText);  
}
//document.getElementById("log").innerHTML = jsonFormated;
const searchInput = document.querySelector(".search_wrapper");
const input = searchInput.querySelector(".input_search");
const resultBox = searchInput.querySelector(".country_list");
let linkTag = searchInput.querySelector("a");
let webLink;

// if user press any key and release
input.onkeyup = (e)=>{
    let userData = e.target.value; //user enetered data
    let emptyArray = [];
    if(userData != ''){
        emptyArray = suggestions.filter((data)=>{
            //filtering array value and user characters to lowercase and return only those words which are start with user enetered chars
            return data.toLocaleLowerCase().startsWith(userData.toLocaleLowerCase()); 
        });
        emptyArray = emptyArray.map((data)=>{
            // passing return data inside li tag
            return data = '<li class="country_itm">'+ data +'</li>';
        });
        showSuggestions(emptyArray);
    }else{
      
      resultBox.innerHTML = ""; 
     for (i = 0; i < suggestions.length; ++i) {
       var li = document.createElement('li');
       li.classList.add("country_itm");
        li.innerText = suggestions[i];
         resultBox.appendChild(li);
      }
    }
}

function showSuggestions(list){
    let listData;
    if(!list.length){
        userValue = input.value;
        listData = '<li class="country_itm text_center"> Sorry, no matching options </li>';
    }else{
        listData = list.join('');
    }
    resultBox.innerHTML = listData;
}
  document.getElementById('country_seletor').addEventListener("focus", (event) => {
  $('.country_list').fadeIn();
});
  $(document).on('click', '.country_itm', function(){
    $('#country_seletor').val($(this).text())
     $('.country_list').fadeOut();
})
}